import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class ButtonSocialShareVkontakteComponent extends Vue {
    @Prop({
        default: () => document.location!.href.replace(document.location!.hash, '')
    })
    pageUrl: string;

    @Prop({
        default: () => document.title
    })
    pageTitle: string;

    @Prop({
        default: () => {
            const meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;

            return meta ? meta.content : '';
        }
    })
    pageDescription: string;

    @Prop({
        default: () => {
            const link = document.querySelector('link[rel="apple-touch-icon"]') as HTMLLinkElement | null;

            return link ? link.href : '';
        }
    })
    pageImage: string;

    @Prop()
    lable: string;

    @Prop({
        default: true
    })
    hasIcon: boolean;

    @Prop({
        default: true
    })
    hasCounter: boolean;

    counter: string = '0';

    mounted() {
        if (this.hasCounter) {
            this.fetchShareCounter();
        }
        this.$root.$on('VK:Share:count:update', this.handleUpdateCount.bind(this));
    }

    destroyed() {
        this.$root.$off('VK:Share:count:update', this.handleUpdateCount.bind(this));
    }

    getRandomInt(min: number, max: number): number {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    sliceThousandInt(number: number): string {
        return (number / 1000).toFixed(1) + 'k';
    }

    showShareWindow(): void {
        const shareUrl = `https://vk.com/share.php` +
            `?url=${encodeURIComponent(this.pageUrl)}` +
            `&title=${encodeURIComponent(this.pageTitle)}` +
            `&description=${encodeURIComponent(this.pageDescription)}` +
            `&image=${encodeURIComponent(this.pageImage)}` +
            `&noparse=true`;
        const width = 640;
        const height = 640;
        const left = screen.width / 2 - width / 2;
        const top = screen.height / 2 - height / 2;
        const windowConfig = `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,scrollbars=no`;

        window.open(shareUrl, 'Share this', windowConfig);
    }

    handleUpdateCount(count) {
        this.counter = count >= 1000
            ? this.sliceThousandInt(count)
            : count;
    }

    fetchShareCounter(): void {
        // Let's see whether some other component has already asked for count.
        if ((<any>window).VK
            && (<any>window).VK.Share
            && typeof (<any>window).VK.Share.count === 'function'
        ) {
            return;
        }

        const script = document.createElement('script');

        script.src = `https://vk.com/share.php` +
            `?act=count` +
            `&index=${this.getRandomInt(1, 2345)}` +
            `&url=${encodeURIComponent(this.pageUrl)}`;
        document.body.appendChild(script);
        (<any>window).VK = {
            Share: {},
            ...(<any>window).VK
        };
        (<any>window).VK.Share.count = (index, count) => {
            if (count) {
                this.$root.$emit('VK:Share:count:update', count);
            }
        };
    }
}
